var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.951,
    height: 40.204,
    viewBox: "0 0 41.951 40.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.976.5A20.794,20.794,0,0,0,0,21.112,20.647,20.647,0,0,0,14.342,40.668c1.049.194,1.433-.444,1.433-.991,0-.489-.017-1.786-.026-3.5-5.835,1.243-7.065-2.765-7.065-2.765A5.5,5.5,0,0,0,6.35,30.392c-1.9-1.278.147-1.252.147-1.252A4.388,4.388,0,0,1,9.71,31.264c1.87,3.152,4.91,2.241,6.109,1.715a4.364,4.364,0,0,1,1.328-2.757c-4.658-.516-9.554-2.288-9.554-10.185a7.875,7.875,0,0,1,2.159-5.531,7.212,7.212,0,0,1,.184-5.455S11.692,8.5,15.7,11.164a20.111,20.111,0,0,1,10.488,0c3.985-2.666,5.742-2.113,5.742-2.113a7.411,7.411,0,0,1,.21,5.455,7.907,7.907,0,0,1,2.15,5.531c0,7.918-4.9,9.661-9.57,10.168a4.891,4.891,0,0,1,1.416,3.814c0,2.758-.026,4.975-.026,5.644,0,.54.367,1.185,1.442.979a20.584,20.584,0,0,0,14.4-19.53A20.8,20.8,0,0,0,20.976.5Z",
    transform: "translate(0 -0.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.835dd4f0.svg";
export { ForwardRef as ReactComponent };